import JobProApi from "../../../dependencies/JobProApi";
import {
  updatePurchaseOrder,
  updateInventoryPurchaseOrder,
} from "../../calendar";
import { FETCH_STANDARD_CREWS_COMPLETE } from "../../standardCrews";

const DELIVERY_MODAL_UPDATE = "DELIVERY_MODAL_UPDATE";
const TOGGLE_DELIVERY_MODAL = "TOGGLE_DELIVERY_MODAL";

const DEFAULT_STATE = {
  form: {},
  purchaseOrder: null,
  resources: [],
  show: false,
  standardCrews: [],
};

// Reducer
export default function (state = DEFAULT_STATE, { payload, type }) {
  switch (type) {
    case DELIVERY_MODAL_UPDATE:
      return {
        ...state,
        form: {
          ...state.form,
          ...payload,
        },
      };
    case FETCH_STANDARD_CREWS_COMPLETE:
      return {
        ...state,
        standardCrews: payload.crews,
      };
    case TOGGLE_DELIVERY_MODAL:
      return payload
        ? {
            ...state,
            ...payload,
            form: payload ? payload.purchaseOrder : {},
            show: !!payload,
          }
        : DEFAULT_STATE;
    default:
      return state;
  }
}

// Action creators
export const deliveryModalConfirm = () => (dispatch, getState) => {
  const { purchaseOrder, form } = getState().modals.deliveryModal;
  const { crew, dateDelivered, deliveryDate } = form;
  if (purchaseOrder.isInventoryPO) {
    dispatch(
      updateInventoryPurchaseOrder(purchaseOrder.id, {
        crew: crew
          ? {
              equipment: crew.equipment ? { id: crew.equipment.id } : null,
              resources: crew.resources.map(
                ({ resource, resourcePercentage }) => ({
                  resource: { id: resource.id },
                  resourcePercentage,
                })
              ),
            }
          : null,
        deliveryDate: deliveryDate,
      })
    );
  } else if (!purchaseOrder.isInventoryPO) {
    dispatch(
      updatePurchaseOrder(purchaseOrder.id, {
        crew: crew
          ? {
              equipment: crew.equipment ? { id: crew.equipment.id } : null,
              resources: crew.resources.map(
                ({ resource, resourcePercentage }) => ({
                  resource: { id: resource.id },
                  resourcePercentage,
                })
              ),
            }
          : null,
        dateDelivered,
      })
    );
  }
  dispatch(toggleDeliveryModal());
};

export const deliveryModalUpdate = (changes) => ({
  type: DELIVERY_MODAL_UPDATE,
  payload: changes,
});

export const toggleDeliveryModal = (eventId) => (dispatch, getState) => {
  if (!eventId) {
    dispatch({
      type: TOGGLE_DELIVERY_MODAL,
      payload: null,
    });
    return;
  }

  const { events } = getState().events;
  const event = events.find((e) => e.id === eventId);
  const purchaseOrderId = event.purchaseOrder
    ? event.purchaseOrder.id
    : event.inventoryPurchaseOrder.iD;

  const purchaseOrderPromise = event.purchaseOrder
    ? JobProApi.purchaseOrders
        .get(purchaseOrderId, {
          fields:
            "id,crew(id,equipment(id,color,name),resources(resource(id,firstName,lastName),resourcePercentage)),dateDelivered,items(id,item(itemType(id,name))quantity,summary),name,office(id),poNumber,status(name),supplier(name)",
        })
        .then((purchaseOrder) => ({ ...purchaseOrder, isInventoryPO: false }))
    : JobProApi.inventoryPurchaseOrders
        .get(purchaseOrderId, {
          fields:
            "id,crew(id,equipment(id,color,name),resources(resource(id,firstName,lastName),resourcePercentage)),deliveryDate,items(id,item(itemType(id,name))quantity,notes),name,office(id),poNumber,status(name),supplier(name)",
        })
        .then((inventoryPurchaseOrder) => ({
          ...inventoryPurchaseOrder,
          isInventoryPO: true,
        }));

  const equipmentPromise = JobProApi.equipment.query(
    {
      schedulable: true,
      "status!": "Inactive",
    },
    {
      fields: "id,name",
      limit: 9999,
    }
  );

  const resourcesPromise = JobProApi.resources.query(
    {
      isActive: true,
      isJobAssignee: true,
    },
    {
      fields: "id,calendarColor,firstName,lastName",
    }
  );

  Promise.all([purchaseOrderPromise, equipmentPromise, resourcesPromise])
    .then(([purchaseOrder, equipment, resources]) => ({
      equipment,
      purchaseOrder,
      resources,
    }))
    .then((payload) => {
      dispatch({
        type: TOGGLE_DELIVERY_MODAL,
        payload,
      });
    });
};
